import { Box, ButtonBase, Stack, styled } from "@mui/material";

export const ProfileGridContainer = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
  gap: theme.spacing(3),
  marginTop: theme.spacing(3),
}));

export const CardContainer = styled(ButtonBase)(({ theme }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: theme.spacing(6, 4.25, 7.25),
  borderRadius: theme.spacing(2.5),
  minWidth: theme.spacing(17.5),
}));

export const CardContent = styled(Stack)({
  zIndex: 1,
  pointerEvents: "none", // Prevent hover interference
});

export const PinLockedSection = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  textAlign: "center",
}));

export const PinLockedIconWrapper = styled(Box)(({ theme }) => ({
  color: theme.palette.dsNeutral.v300,
  fontSize: 64,
  marginTop: theme.spacing(4),
}));
